import { userViewerSettingsAtom } from '@/atoms/user.atom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ViewerSettingsDialog } from '@/components/ViewerSettingsDialog';
import { Eye } from '@mynaui/icons-react';
import { useAtomValue } from 'jotai';
import { FunctionComponent, useState } from 'react';

interface ViewerSettingsProps {
  userId: string;
}

interface iLabelProps {
  title: string;
  description: string;
}
const Label: FunctionComponent<iLabelProps> = ({ title, description }) => {
  return (
    <div className='flex flex-col gap-1'>
      <h3 className='font-medium leading-none text-slate-900 dark:text-white'>{title}</h3>
      <p className='text-sm font-medium leading-none text-slate-500 dark:text-white/70'>{description}</p>
    </div>
  );
};

export const ViewerSettings: FunctionComponent<ViewerSettingsProps> = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const viewerSettings = useAtomValue(userViewerSettingsAtom);

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Settings</CardTitle>
          <CardDescription>Your personal preferences</CardDescription>
        </CardHeader>
        <CardContent>
          <div className='space-y-4'>
            <div className='flex items-center justify-between'>
              <Label
                title='Viewer Preferences'
                description='Configure point cloud rendering and layer display options'
              />

              <Button variant='outline' onClick={() => setDialogOpen(true)}>
                <Eye className='h-4 w-4 mr-2 stroke-2' />
                Configure Settings
              </Button>
            </div>

            {/* Display current settings */}
            {viewerSettings && (
              <div className='mt-4 px-4 py-3 bg-slate-50 dark:bg-stone-900 rounded-sm border border-slate-200 dark:border-stone-800 space-y-2'>
                <h4 className='text-sm font-medium text-slate-700 dark:text-white'>Current Settings</h4>
                <div className='text-xs font-medium text-slate-600 dark:text-white/70 space-y-1'>
                  <div>
                    Point Cloud Size: {viewerSettings.pointCloudPointSizeType === 'ADAPTIVE' ? 'Adaptive' : 'Fixed'}
                  </div>
                  {viewerSettings.pointCloudPointSizeType === 'FIXED' && (
                    <div>Point Cloud Fixed Size: {viewerSettings.pointCloudPointSize}px</div>
                  )}
                  <div>Point Cloud Point Budget: {viewerSettings.pointCloudPointBudget.toLocaleString()} points</div>
                  <div>Show Layer Source: {viewerSettings.showLayerSource ? 'Enabled' : 'Disabled'}</div>
                  <div>Show Layer Under Type: {viewerSettings.showLayerUnderType ? 'Enabled' : 'Disabled'}</div>
                  <div>Show Image POIs: {viewerSettings.showImagePOIs ? 'Enabled' : 'Disabled'}</div>
                </div>
              </div>
            )}
          </div>
        </CardContent>
      </Card>

      {dialogOpen && <ViewerSettingsDialog open={dialogOpen} onOpenChange={setDialogOpen} />}
    </>
  );
};
